import { Button } from '@mui/material';
import { AlertDialog } from '../../../../components/AlertDialog';
import { t } from 'i18next';
import { useState } from 'react';
import { useAgreements } from '../../../../hooks/api/useAgreements';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../../contexts/AuthContext';

export const DeleteAgreementModal = ({
  id,
  journalMode,
  journalId,
}: {
  id: string;
  journalMode: boolean;
  journalId: string | undefined;
}) => {
  const { impersonationLock } = useAuthContext();
  const { deleteAgreementById, deleteJournal } = useAgreements();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    if (journalMode) {
      await deleteJournal(id, journalId!);
      handleClose();
      navigate(0);
    } else {
      await deleteAgreementById(id);
      handleClose();
      navigate('/agreements');
    }
  };

  return (
    <>
      <Button
        variant="warningLink"
        onClick={handleOpen}
        disabled={impersonationLock}
      >
        {journalMode
          ? t('agreements.deleteJournal')
          : t('agreements.deleteAgreement')}
      </Button>
      <AlertDialog
        variant="alert"
        open={open}
        onClose={handleClose}
        title={t('agreements.areYouSureTitle')}
        description={
          journalMode
            ? t('agreements.areYouSureMsgJournal')
            : t('agreements.areYouSureMsg')
        }
        actions={{
          cancel: {
            label: t('agreements.cancelDelete'),
            onClick: handleClose,
          },
          confirm: {
            label: journalMode
              ? t('agreements.confirmDeleteJournal')
              : t('agreements.confirmDelete'),
            onClick: handleConfirm,
          },
        }}
      />
    </>
  );
};
